// @flow
import React from 'react';
import useLazy from '../../hooks/useLazy';

type Props = {
  iconName: string,
  className?: string
};

const LandingPageIcon = ({ iconName, className = '' }: Props) => {
  const [loaded, ref] = useLazy(
    import(
      /* webpackChunkName: "component-landingpage-icons" */ './LandingPageIcons'
    )
  );

  return (
    <div className={className}>
      {loaded ? <ref.current iconName={iconName} /> : <div />}
    </div>
  );
};

export default LandingPageIcon;
